import React from 'react';
import {
  HeadingRegular,
  BodyR,
  Title3,
  CalloutM,
} from '@pensionbee/honeypot-ui';
import { ThemedImage } from '@/domains/theme/ThemedImage';
import globalVariables from '@/domains/shared/data/globalVariables';

const HavingTroubleError = () => {
  const GENERAL_ENQUIRIES_PHONE_NUMBER =
    globalVariables.pensionbeeContactPhoneNumber;

  return (
    <>
      <div className="flex justify-center items-center">
        <ThemedImage
          name="errorIcon"
          alt="Too many attempts Error"
          width={120}
          height={120}
        />
      </div>
      <div className="pt-28">
        <HeadingRegular as="h1">You seem to be having trouble</HeadingRegular>
      </div>
      <div className="pt-28">
        <BodyR>
          {' '}
          You have reached the limit of attempts, please try again later or for
          support please contact us.{' '}
        </BodyR>
      </div>
      <div className="pt-28">
        <BodyR>
          {' '}
          Ensure you have your national insurance number to hand so we can
          confirm your identity.{' '}
        </BodyR>
      </div>
      <div className="pt-28">
        <a
          href={`tel:${GENERAL_ENQUIRIES_PHONE_NUMBER.replace(/\s+/g, '')}`}
          className="text-blue-100 underline font-bold hover:text-blue-100"
        >
          <Title3> {GENERAL_ENQUIRIES_PHONE_NUMBER} </Title3>
        </a>
        <div>
          <CalloutM>Monday - Friday: 9:30am - 5pm </CalloutM>
        </div>
      </div>
    </>
  );
};

export default HavingTroubleError;
